import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { Register } from "./Register";
import { Login } from "./Login";

export const RootLayout = () => {
  return <Outlet />;
};
